/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CreditAnalyticsDay } from './creditAnalyticsDay';
import type { CreditAnalyticsOverview } from './creditAnalyticsOverview';
import type { CreditCategoryStat } from './creditCategoryStat';
import type { CreditMemberStat } from './creditMemberStat';

export interface CreditAnalyticsResponse {
  days: number;
  timezone: string;
  /** @maxItems 365 */
  series: CreditAnalyticsDay[];
  overview: CreditAnalyticsOverview;
  by_category: CreditCategoryStat[];
  by_member: CreditMemberStat[];
}
